import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { apiClient } from "@/lib/api";

// Thin router: validates token exists, then always hands off to CollaboratorOnboardingPage.
export default function AcceptInvitationPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const init = async () => {
      if (!token) return;
      try {
        // Validate invitation token; we ignore the response
        await apiClient.getInvitationDetails(token);
        navigate(`/invite/onboarding/${token}`, { replace: true });
      } catch (error: any) {
        const errorMessage =
          error?.response?.data?.detail ||
          "Failed to process invitation. It might be expired.";
        toast.error(errorMessage);
        navigate("/", { replace: true });
      }
    };
    void init();
  }, [token, navigate]);

  return (
    <div className="flex items-center justify-center h-screen">
      <p>Validating invitation...</p>
    </div>
  );
}